<template>
    <button class="actionButton" @click="doClick" :disabled="disabled">
        <div class="mark">
            <IconBase><IconEraser /></IconBase>
        </div>
        <div class="txt">削除</div>
    </button>
</template>

<script>
import MopButtonMixin from "@/components/buttons/MopButtonMixin.vue";
import IconEraser from "@/components/icons/IconEraser.vue";

export default {
    name: "MopDeleteButton",
    mixins: [MopButtonMixin],
    components: {
        IconEraser
    }
};
</script>
